import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

@Injectable()
export class UniversalInterceptorService implements HttpInterceptor {
  constructor(@Optional() @Inject('serverUrl') protected serverUrl: string) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (/^https?:\/\//i.test(req.url)) {
      return next.handle(req);
    }

    const url = (this.serverUrl || 'https://planetakvitiv.com.ua').replace(/\/+$/, '');
    const path = req.url.startsWith('/') ? req.url : `/${req.url}`;
    const serverReq = req.clone({
      url: `${url}${path}`
    });
    // const serverReq = !this.serverUrl
    //   ? req
    //   : req.clone({
    //     url: `${url}${req.url}`
    //   });

    return next.handle(serverReq);
  }
}
